<img [src]="spinner" [style.width.px]="size" [style.height.px]="size">
